import Vue from 'vue'
import VueRouter from 'vue-router'

// import Preload from './Preload'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   redirect:
  //   {
  //     name: 'Home'
  //   }
  // },
  // {
  //   path: '/preload',
  //   name: 'Preload',
  //   component: Preload
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
